class FileUploadValidator {
    constructor(form) {
        this.form = form
        this.inputs = [...form.querySelectorAll('[data-min-size]')]
        this.targetFileCount = 5

        this.register()
        this.init()
    }

    register() {
        // attach to form (simple plugin system)
        this.form._validators ??= []
        this.form._validators.push(this)
    }

    init() {
        if (!this.inputs.length) return

        this.inputs.forEach(input => {
            input.addEventListener('change', (e) => this.handleChange(e))
        })
    }

    handleChange(e) {
        const input = e.target
        this.clearErrors(input)

        this.validateFileCount(input)
        this.validateMinSize(input)
    }

    validate(scope) {
        const inputs = this.inputs.filter(input => scope.contains(input))

        return inputs.every(input => {
            this.clearErrors(input)

            const validCount = this.validateFileCount(input)
            const validSize = this.validateMinSize(input)


            return validCount

            // validSize not enforced 
            //return validCount && validSize
        })
    }

    validateFileCount(input) {
        const count = input.files.length
        const warning = input.dataset.maxFileCountWarning

        if (count !== this.targetFileCount) {
            this.showFlash(input, warning, 'error')
            return false
        }

        return true
    }

    validateMinSize(input) {
        const minSize = Number(input.dataset.minSize)
        const warning = input.dataset.minSizeWarning

        return [...input.files].every(file => {
            if (file.size < minSize) {
                this.showFlash(input, warning)
                return false
            }
            return true
        })
    }

    clearErrors(input) {
        input.parentElement
            .querySelectorAll('[data-error-message]')
            .forEach(el => el.remove())
    }

    showFlash(input, message, type = 'warning') {
        input.insertAdjacentHTML(
            'afterend',
            `<p class="alert alert--${type}" data-error-message>${message}</p>`
        )
    }
}

export default FileUploadValidator